import { Component, Injector, Input } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { filter, takeUntil } from 'rxjs';
import { TBSBaseComponent } from 'src/app/shared/models/tbsBaseComponent';
import { AiChatService } from 'src/app/modules/ai-chat/ai-chat.service';
import { GlobalObjectsService } from 'src/app/shared/services/global-objects.service';
@Component({
  selector: 'app-masthead-ai-avatar',
  templateUrl: './masthead-ai-avatar.component.html',
  standalone: false
})
export class MastheadAiAvatarComponent extends TBSBaseComponent {
  /** Mirrors aiChatService.openChat$ — that service is the source of truth. */
  isChatPanelOpen = false;

  @Input() isMobile = false;
  isNiceChatWindowOpen: boolean = false;

  constructor(
    injector: Injector,
    private readonly aiChatService: AiChatService,
    private readonly router: Router,
    private readonly globalObjectsService: GlobalObjectsService
  ) {
    super(injector);
    this.addResourceStringKeys(['Aon.AI.Avatar.CloseChat', 'Aon.AI.Avatar.AonAiChat', 'Aon.AI.Avatar.OpenChat']);
    this.aiChatService.openChat$
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(shouldOpen => shouldOpen ? this.openChatPanel() : this.closeChatPanel());
  }
  ngOnInit(): void {
    this.loadResourceStringAsObservable()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(res => this.getResouceStringsAsObject(res));

    this.globalObjectsService.niceChatWindowState
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(state => {
        this.isNiceChatWindowOpen = state === 'open';
      });

    this.router.events
      .pipe(
        filter(event => event instanceof NavigationStart),
        takeUntil(this.unsubscribe)
      )
      .subscribe(() => {
        if (this.isChatPanelOpen) {
          // Navigating away: focus belongs to the new page, not back on the toggle.
          this.closeChatPanel(false);
        }
      });
  }

  toggleChatPanel(): void {
    if (this.isChatPanelOpen) {
      this.aiChatService.closeChat();
    } else {
      this.aiChatService.openChatWithQuery('');
    }
  }
  openChatPanel(): void {
    this.isChatPanelOpen = true;
  }
  closeChatPanel(restoreFocus = true): void {
    const wasOpen = this.isChatPanelOpen;
    this.isChatPanelOpen = false;
    // Every way of closing the chat (toggle, Esc, backdrop click) ends up here via
    // openChat$, so this is the one place that can return focus to the toggle.
    if (wasOpen && restoreFocus) {
      requestAnimationFrame(() => {
        const toggle = document.getElementById('ai-chat-avatar-toggle');
        const active = document.activeElement;
        // Only reclaim focus if it has been lost (body) or is stranded in the panel that's going away.
        if (toggle && (!active || active === document.body || active.closest('.ai-chat-panel'))) {
          toggle.focus();
        }
      });
    }
  }
}
